import { useState } from 'react'
import { apiClient } from '../lib/api-client'
import { ApiError } from '../lib/errors'
import { SUPPORT_EMAIL } from '../lib/legal'

/**
 * The header's "Billing" link (SOL-204): Stripe's portal, for invoices and
 * payment methods. It replaces the account banner's "Manage billing" — with
 * one-time purchases there is no subscription to rescue, but a VAT invoice is
 * exactly what a business buyer comes back for.
 *
 * A user with no Stripe customer has bought nothing yet to show, which is a
 * message, not an error.
 */
export default function BillingLink(): JSX.Element {
  const [busy, setBusy] = useState(false)
  const [note, setNote] = useState<string | null>(null)

  async function open(): Promise<void> {
    setBusy(true)
    setNote(null)
    try {
      const { url } = await apiClient.createBillingPortalSession(window.location.origin + '/')
      window.location.href = url
    } catch (e) {
      setNote(
        e instanceof ApiError && e.code === 'NO_BILLING_CUSTOMER'
          ? 'No purchases to show yet.'
          : `Could not open billing. Please try again, or write to ${SUPPORT_EMAIL}.`,
      )
      setBusy(false)
    }
  }

  return (
    <span className="billing-link">
      <button className="billing-link__btn" onClick={() => void open()} disabled={busy}>
        {busy ? 'Opening…' : 'Billing'}
      </button>
      {note && <span className="billing-link__note" role="status">{note}</span>}
    </span>
  )
}
